export default "__VITE_ASSET__RYaVF07r__"